<template>
  <router-link :to="{ name: 'CompaniesInitialSettingGuide'}" class="initialSettingGuideLinkButton">
    <div v-if="count > 0" class="initialSettingGuideLinkButton__count">
      {{ count }}
    </div>
    <div class="initialSettingGuideLinkButton__icon">
      <Icon name="iconVector" :style="{ width: '26px', height: '35px' }" />
    </div>
    <div class="initialSettingGuideLinkButton__text">
      <p>
        {{ $t('pages.CompaniesDashboards.InitialSettingGuideLinkButton.description') }}
      </p>
      <p class="initialSettingGuideLinkButton__linkText">
        {{ $t('pages.CompaniesDashboards.InitialSettingGuideLinkButton.link') }}→
      </p>
    </div>
  </router-link>
</template>

<script>
import Icon from '../Icon'
export default {
  name: 'InitialSettingGuideLinkButton',
  components: { Icon },
  props: {
    count: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../stylesheets/biz_spa/foundation/_var.scss';

.initialSettingGuideLinkButton {
  position: relative;
  background: linear-gradient(0deg, #4A6279, #4A6279), linear-gradient(0deg, #4285A2, #4285A2), linear-gradient(0deg, #E9446A, #E9446A), $complete-color;
  border-radius: 4px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-around;
  text-decoration: none;
  padding: 24px 18px;
  &__text {
    color: #FFFFFF;
    font-weight: bold;
    font-size: 12px;
  }
  &__linkText {
    font-size: 20px;
  }
  &__count {
    position: absolute;
    background-color: $color-accent-primary;
    color: #FFFFFF;
    font-weight: bold;
    top: -14px;
    right: -14px;
    border-radius: 14px;
    padding: 3px 9px;
  }
}
</style>
